module.exports = __webpack_public_path__ + "img/integrations.038395e5.svg";